import { RawTextModel } from '@flocasts/experience-service-types'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'flo-raw-text',
  templateUrl: './raw-text.component.html',
  styleUrls: ['./raw-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RawTextComponent {
  @Input()
  rawText: RawTextModel
}
